import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import Loader from '../../widgets/Loader/Loader';
import BackgroundCanvasWithoutRadar from '../../widgets/canvas/BackgroundCanvasWithoutRadar';
import './IncyRedirectPage.scss';

function IncyRedirectPage() {
    const {key} = useParams<{ key: string }>();
    const [showFallback, setShowFallback] = useState(false);

    useEffect(() => {
        if (!key) return;

        const subscriptionUrl = `https://sub.shadownet.nl/${key}`;
        const incyDeepLink = `incy://add/${subscriptionUrl}`;

        window.location.href = incyDeepLink;

        const fallbackTimer = setTimeout(() => {
            setShowFallback(true);
        }, 2000);

        return () => clearTimeout(fallbackTimer);
    }, [key]);

    const handleOpenIncy = () => {
        const subscriptionUrl = `https://sub.shadownet.nl/${key}`;
        const incyDeepLink = `incy://add/${subscriptionUrl}`;
        window.location.href = incyDeepLink;
    };

    if (!key) {
        return (
            <div className="tg-app">
                <BackgroundCanvasWithoutRadar/>
                <div className="incy-redirect-page">
                    <div className="incy-redirect-error">
                        <div className="incy-redirect-error-icon">⚠️</div>
                        <h2>Неверная ссылка</h2>
                        <p>Ключ подписки не найден в ссылке</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="tg-app">
            <BackgroundCanvasWithoutRadar/>
            <div className="incy-redirect-page">
                <div className="incy-redirect-content">
                    <h2>Открываем Incy...</h2>
                    <p>Перенаправление в приложение</p>

                    {showFallback ? (
                        <button
                            className="device-detail-action-btn device-detail-action-primary"
                            onClick={handleOpenIncy}
                        >
                            <span>Открыть в Incy</span>
                        </button>
                    ) : (
                        <div className="incy-redirect-loader">
                            <Loader/>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default IncyRedirectPage;